import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import * as Styled from './styled';

function OmniboxButton({
  currentLocOrFavorites,
  navigateToOmnibox,
  className,
}) {
  const intl = useIntl();
  return (
    <Styled.OmniboxButtonWrapper className={className}>
      <Styled.OmniButton
        $currentLocOrFavorites={currentLocOrFavorites}
        onClick={() => navigateToOmnibox()}
      >
        <Styled.SearchIcon
          $currentLocOrFavorites={currentLocOrFavorites}
          title={intl.formatMessage({ id: 'navbar.search' })}
          aria-hidden="true"
        />
        <FormattedMessage id="navbar.search" />
      </Styled.OmniButton>
    </Styled.OmniboxButtonWrapper>
  );
}

OmniboxButton.propTypes = {
  currentLocOrFavorites: PropTypes.bool,
  navigateToOmnibox: PropTypes.func.isRequired,
  className: PropTypes.string,
};

OmniboxButton.defaultProps = {
  currentLocOrFavorites: false,
  className: null,
};

export default OmniboxButton;
